export { PromotionCard } from './PromotionCard';
